// Cliente Supabase usado por el CRM (/admin/*).
// Si SUPABASE_PROXY_URL está definido, las peticiones van a tu Cloudflare
// Worker (p.ej. https://api.levellocal.com) en vez de a *.supabase.co.
// Esto evita bloqueos por extensiones, antivirus o firewalls corporativos
// que filtran el dominio supabase.co.
//
// Para activarlo:
//   1. Despliega worker/supabase-proxy.js como Cloudflare Worker.
//   2. Asocia un dominio propio (p.ej. api.levellocal.com).
//   3. Pon esa URL aquí abajo.
//   4. Deja "" para volver al comportamiento por defecto.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

// URL del Cloudflare Worker que hace de proxy hacia Supabase.
// Cambia este valor si tu Worker está en otro dominio.
// Déjalo en "" SOLO si quieres volver a llamar directo a *.supabase.co.
const SUPABASE_PROXY_URL = "https://api.levellocal.com";

const DEFAULT_URL = import.meta.env.VITE_SUPABASE_URL as string;
const PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string;

const isLovablePreviewHost =
  typeof window !== "undefined" &&
  (window.location.hostname.includes("lovableproject.com") || window.location.hostname.startsWith("id-preview--"));

// En la preview de Lovable, api.levellocal.com puede no resolver todavía.
// Para que el admin sea usable durante la edición, solo ahí usamos la URL directa.
// En producción se mantiene forzado el proxy propio.
const URL_TO_USE = isLovablePreviewHost ? DEFAULT_URL : SUPABASE_PROXY_URL || DEFAULT_URL;

export const supabaseAdmin = createClient<Database>(URL_TO_USE, PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    storageKey: "ll-admin-auth",
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    headers: { "x-client-info": "levellocal-crm" },
  },
});

export const isProxyActive = URL_TO_USE === SUPABASE_PROXY_URL;
export const activeSupabaseUrl = URL_TO_USE;